import { render, staticRenderFns } from "./linkedin-share-btn.vue?vue&type=template&id=53eb7b84&"
import script from "./linkedin-share-btn.vue?vue&type=script&lang=js&"
export * from "./linkedin-share-btn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports